import { Duplexer } from '@wix/duplexer-js';
export const DUPLEXER_EVENTS = {
  STATUS_UPDATE: 'status_update',
  TRASH_FILE: 'trash_file',
  ITEM_UPDATE: 'item_update',
  COPY_FILE: 'copy_file',
  COPY_FOLDER: 'copy_folder'
};
const duplexerSocketsServerUrl = 'duplexer.wix.com';
const channelName = '@private-media';
const privateMediaAppDefId = '150e0622-5b83-6135-b985-b7b05be0848e';
let appConnection = null;
export const createDuplexerChannel = _ref => {
  let {
    metaSiteToken
  } = _ref;
  let channel = null;
  let duplexer = null;
  if (!appConnection) {
    duplexer = new Duplexer(duplexerSocketsServerUrl, {
      instanceUpdater: {
        getInstance: () => metaSiteToken
      }
    });
    appConnection = duplexer.connect({
      appDefId: privateMediaAppDefId
    });
    channel = appConnection.subscribe(channelName);
    channel.on('@duplexer:subscription_failed', () => {
      appConnection = null;
    });
  } else {
    duplexer = appConnection.duplexer;
    channel = appConnection.channels.channelsList.find(_ref2 => {
      let {
        name
      } = _ref2;
      return name === channelName;
    });
  }
  const destroy = () => {
    duplexer.removeAllListeners();
    duplexer.close();
  };
  return {
    channel,
    destroy
  };
};